import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import {
  ORGANISATION_ROLES_RESOURCE,
  ORGANISATION_ROLE_RESOURCE,
  UPDATE_ORGANISATION_ROLE_RESOURCE,
} from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_ORGANISATION_ROLE_RESOURCE,
      method: 'put',
      request: (tag, body, callback, t) => ({
        url: apiRoutes.organisationRoles(tag),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: ORGANISATION_ROLES_RESOURCE,
            id: tag,
            idProp: 'tag',
            listPath: 'organisationRoles',
            valuesModifier: values => ({ ...body, ...values }),
          },
          setOther: {
            resource: ORGANISATION_ROLE_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateOrganisationRoleFailed'),
            onSuccessMessage: t('updateOrganisationRoleSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
